//For Sidebar design
let defaultConfig = {
	fields_view_headers: "Underwriting",
	fields_edit_headers: "Underwriting Fields",
	background: "white",
	menuitembackground: "#E0E0E0",
	iconcolor: "#2E2C32",
	activeiconcolor: "#2E2C32",
	polcolor: "primary",
};

function getUiPrefrenceObject(user: any) {
	let config: any;

	if (user.type === "lender") {
		config = user?.company?.company_configurations?.[0]?.ui_prefrences;
	} else if (user.type === "borrower") {
		config = user?.lender_company?.company_configurations?.[0]?.ui_prefrences;
	}
	if (!config) {
		return defaultConfig;
	}
	return config;
}

export const getSidebarBackground = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config)
		return config.background ? config.background : defaultConfig.background;
	else return defaultConfig.background;
};

export const getMenuItemBackground = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config) {
		return config.menuitembackground
			? config.menuitembackground
			: defaultConfig.menuitembackground;
	} else return defaultConfig.menuitembackground;
};

export const getIconColor = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config) {
		return config.iconcolor ? config.iconcolor : defaultConfig.iconcolor;
	} else return defaultConfig.iconcolor;
};

export const getIconActiveColor = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config) {
		return config.activeiconcolor
			? config.activeiconcolor
			: defaultConfig.activeiconcolor;
	} else return defaultConfig.activeiconcolor;
};

export const menutItemPolColor = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config) {
		return config.polcolor ? config.polcolor : defaultConfig.polcolor;
	} else return defaultConfig.polcolor;
};

export const getFieldViewHeader = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config)
		return config.fields_view_headers
			? config.fields_view_headers
			: defaultConfig.fields_view_headers;
	else return defaultConfig.fields_view_headers;
};

export const getFieldEditHeader = (user: any) => {
	const config = getUiPrefrenceObject(user);
	if (config)
		return config.fields_edit_headers
			? config.fields_edit_headers
			: defaultConfig.fields_edit_headers;
	else return defaultConfig.fields_edit_headers;
};

//For company logo URL
function getCompanyLogoUrlObject(user: any) {
	let CompanyUrl: any;

	if (user.type === "lender") {
		CompanyUrl = user?.company?.company_configurations?.[0]?.company_website;
	} else if (user.type === "borrower") {
		CompanyUrl =
			user?.lender_company?.company_configurations?.[0]?.company_website;
	}
	if (!CompanyUrl) {
		return "";
	}
	return CompanyUrl;
}

export const getCompanyUrl = (user: any) => {
	let CompanyUrl = getCompanyLogoUrlObject(user);
	if (CompanyUrl) {
		return CompanyUrl.url;
	} else {
		return "";
	}
};

//To get the Interest Rate value
//For Interest Rate value
export const pullInterestRate = (loan: any) => {
	let loanObj =
		loan?.values?.find(
			(v: {
				loan_field: { data_key: any };
				value: { field: { InterestRate?: number } };
			}) =>
				v?.loan_field?.data_key === "custom_interest_rate" &&
				v?.value?.field !== null
		)?.value?.field?.InterestRate ?? null;
	if (loanObj) {
		return `${loanObj}`;
	} else {
		return "Not Provided";
	}
};

export const pullNoramlInterestRate = (loan: any) => {
	const loanObj =
		loan?.values?.find(
			(v: {
				loan_field: { data_key: any };
				value: { field: { InterestRate?: number } };
			}) =>
				v?.loan_field?.data_key === "interest_rate" && v?.value?.field !== null
		)?.value?.field ?? null;
	if (loanObj) {
		return `${loanObj}`;
	} else {
		return "Not Provided";
	}
};

//For LoanType value(options)
export const getLoanType = (loan: any) => {
	let loanObj =
		loan?.values?.find(
			(v: {
				loan_field: { data_key: any };
				value: { field: { InterestRate?: number } };
			}) =>
				v?.loan_field?.data_key === "custom_interest_rate" &&
				v?.value?.field !== null
		)?.value?.field?.LoanType ?? null;
	if (loanObj) {
		return `${loanObj}`;
	} else {
		return "Not Provided";
	}
};

//same fields
//get funding date
export const getFundingDate = (loan: any) => {
	let loanObj =
		loan?.values?.find(
			(v: {
				loan_field: { label: string };
				value: { field: { InterestRate?: number } };
			}) => v?.loan_field?.label === "Funding Date" && v?.value?.field !== null
		)?.value?.field ?? null;
	if (loanObj) {
		return `${loanObj}`;
	} else {
		return null;
	}
};

//get Project dureation date
export const getDuration = (loan: any) => {
	let loanObj =
		loan?.values?.find(
			(v: {
				loan_field: { label: string };
				value: { field: { InterestRate?: number } };
			}) =>
				v?.loan_field?.label === "Project Duration (months)" &&
				v?.value?.field !== null
		)?.value?.field ?? null;
	if (loanObj) {
		return `${loanObj}`;
	} else {
		return 0;
	}
};

//get holiday period in months :
export const getHolidayPeriod = (loan: any) => {
	let loanObj =
		loan?.values?.find(
			(v: {
				loan_field: { label: string };
				value: { field: { InterestRate?: number } };
			}) =>
				v?.loan_field?.label === "Holiday Period" && v?.value?.field !== null
		)?.value?.field ?? null;
	if (loanObj) {
		return `${loanObj}`;
	} else {
		return 0;
	}
};

//Get custom currency from DB
export const getCustomCurrency = (user: any) => {
	let currency = "$";
	if (user.type === "lender") {
		currency =
			user?.company?.company_configurations?.[0]?.custom_currency?.currency;
	} else if (user.type === "borrower") {
		currency =
			user?.lender_company?.company_configurations?.[0]?.custom_currency
				?.currency;
	}
	return currency || "$";
};

//Get custom buttons styles from DB
export const getCustomButtonVariant = (user: any) => {
	let customButtons = "solid";

	if (user.type === "lender") {
		customButtons =
			user?.company?.company_configurations?.[0]?.ui_prefrences
				?.custombuttonvarient;
	} else if (user.type === "borrower") {
		customButtons =
			user?.lender_company?.company_configurations?.[0]?.ui_prefrences
				?.custombuttonvarient;
	}
	return customButtons;
};

export const checkUiConfiguration = (
	user: any,
	key: any,
	defaultValue = false
) => {
	const configuration: undefined | Record<string, unknown> =
		user.type === "lender"
			? user?.company?.company_configurations?.[0]?.ui_prefrences
			: user?.lender_company?.company_configurations?.[0]?.ui_prefrences;

	return configuration?.[key] ?? defaultValue;
};
